import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { SECTIONS } from "../../lib/planReview";
import { MyNutrition } from "../../components/nutrition/MyNutrition";

const Box = ({ title, children, testid }) => (
  <div className="qv-card-app" style={{ padding: 20, marginBottom: 16 }} data-testid={testid}>
    <div className="label" style={{ color: "var(--qv-red)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>{title}</div>
    {children}
  </div>
);

export default function MyPlanning() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [unseen, setUnseen] = useState(false);
  useEffect(() => {
    api.get("/me/planning").then((r) => setD(r.data)).catch((e) => setErr(formatErr(e)));
    api.get("/me/area").then((r) => setUnseen(r.data.planning.update_unseen)).catch(() => {});
  }, []);
  const ack = () => api.post("/me/planning/ack-update").then(() => setUnseen(false)).catch(() => {});

  return (
    <AppShell>
      <div className="qv-page-head" data-testid="my-planning-page">
        <div className="label">Tu plan</div>
        <h1>Mi planificación</h1>
      </div>
      {err && <p style={{ color: "#f87171" }}>{err}</p>}
      {!d && !err && <p style={{ color: "#a3a3a3" }}>Cargando…</p>}
      {d && d.state !== "published" && (
        <Box title="Estado" testid="my-planning-pending">
          <div style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 15 }}>
            <Clock size={18} color="#facc15" />
            {d.state === "pending_review" ? "Tu planificación está pendiente de revisión por tu entrenador. Te avisaremos cuando esté lista." : "Todavía no tienes una planificación asignada."}
          </div>
        </Box>
      )}
      {d && d.state !== "published" && <MyNutrition />}
      {d?.state === "published" && (<>
        {unseen && <Box title="Planificación actualizada" testid="my-planning-new-version"><div style={{ fontSize: 14, display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", flexWrap: "wrap" }}>Tu entrenador ha publicado una nueva versión. Ya ves la versión actualizada.<button className="qv-btn-ghost" onClick={ack} style={{ padding: "6px 12px", fontSize: 12 }} data-testid="my-planning-ack">Entendido</button></div></Box>}
        {d.update_in_review && <Box title="Aviso" testid="my-planning-update"><div style={{ fontSize: 14 }}>Tu entrenador está preparando una actualización. Mientras tanto sigue esta planificación.</div></Box>}
        <Box title={d.plan_name || "Planificación"} testid="my-planning-published">
          <div style={{ fontSize: 12, color: "#a3a3a3" }}>Publicada el {new Date(d.published_at).toLocaleDateString("es-ES")}</div>
        </Box>
        {SECTIONS.filter(([k]) => d.sections[k]).map(([k, l]) => (
          <Box key={k} title={l} testid={`my-planning-${k}`}><div style={{ whiteSpace: "pre-wrap", fontSize: 14, lineHeight: 1.6 }}>{d.sections[k]}</div></Box>
        ))}
        <MyNutrition />
        <Box title="Entrenamientos" testid="my-planning-weeks">
          {d.weeks.map((w, i) => (
            <div key={i} style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 700 }}>{w.label || `Semana ${i + 1}`}</div>
              <div style={{ fontSize: 13, color: "#a3a3a3" }}>{(w.days || []).map((x) => x.title || x.day_type).join(" · ")}</div>
            </div>
          ))}
          <div style={{ fontSize: 12, color: "#737373", marginTop: 8 }}>Las sesiones detalladas están en tu calendario de Entrenamiento.</div>
        </Box>
      </>)}
    </AppShell>
  );
}
